import { useMemo } from "react"
import type { ReactElement } from "react"

import { DialogWindow, DialogWindowHeader } from ".."
import { AttachmentIcon, ImageViewer, VideoPlayer } from "../../atoms"

import "./media-dialog.styles.scss"
import { Box } from "@material-ui/core"
import { AttachmentType } from "../../../models"

export enum MediaType {
  YouTube = 0,
  Image = 1
}

export interface IMediaDialogProps {
  open: boolean
  type: AttachmentType
  title: string
  source?: string
  onClose: () => void
}

export function MediaDialog(props: IMediaDialogProps): ReactElement {
  const { open, type, source, title, onClose } = props
  // biome-ignore lint/correctness/useExhaustiveDependencies: TODO in a later PR
  const mediaType: MediaType = useMemo(() => {
    return getMediaType()
  }, [type])

  function getMediaType(): MediaType {
    switch (type) {
      case AttachmentType.Video:
        return MediaType.YouTube
      default:
        return MediaType.Image
    }
  }

  return (
    <DialogWindow open={open} className="media-dialog">
      <DialogWindowHeader
        title={title}
        icon={
          <AttachmentIcon
            color="#2965fb"
            type={mediaType === MediaType.YouTube ? AttachmentType.Video : AttachmentType.Image}
          />
        }
        onClose={onClose}
      />

      <Box className="media-dialog-content">
        {mediaType === MediaType.YouTube && source && <VideoPlayer videoUrl={source} />}
        {mediaType === MediaType.Image && source && <ImageViewer source={source} alt={title} />}
      </Box>
    </DialogWindow>
  )
}
